/* Branding reducer */

import * as _ from 'lodash';

import * as Actions from '../actions';

export interface IBrandingLogo {
    login: string;
    nav: string;
    reportCoverPage: string;
    reportFooter: string;
    reportPortal: string;
    bidLetterHeader: string;
    bidLetterFooter: string;
}

export interface IBrandingState {
    brandKey: string;
    companyName: string;
    copyrightYears: string;
    logo: IBrandingLogo;    
}

const initialBrandingState: IBrandingState = {
    brandKey: '',
    companyName: '',
    copyrightYears: '2023',
    logo: {
        nav: '',
        login: '',
        reportCoverPage: '',
        reportFooter: '',
        reportPortal: '',
        bidLetterHeader: '',
        bidLetterFooter: '',
    },
};

export function brandingReducer(state: IBrandingState = initialBrandingState, action: any): IBrandingState {    
    switch (action.type) {
        // case Actions.SIDEBAR_NAVIGATION_COLLAPSED:
        //     return _.merge({}, state, { sidebarCollapsed: action.collapsed });        
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/brandingReducer.tsx